import type {ReactNode} from 'react';

import {Box, Flex} from '@tempo/core';

type PageLayoutProps = {
	children: ReactNode;
	testId?: string;
};

export const PageLayout = ({
	children,
	testId = 'PageLayout',
}: PageLayoutProps) => {
	return (
		<Flex
			data-testid={testId}
			direction="column"
			flex="1"
			bg="background.neutral.primary.default"
		>
			<Box flex="1" display="flex" flexDirection="column">
				{children}
			</Box>
		</Flex>
	);
};
